export const FTUEConstants = {
  kSeenFTUESlideshowKey: 'SKZFTUEVideoIntroViewed',
  kCreatedProfileTutorialKey: 'SKZFTUEProfileCreated',
  kJoinedFirstFTUETournamentKey: 'SKZFTUEHasJoinedFirstTournament',
  kVersusTutorialOneKey: 'SKZFTUEVersusTutorialOneViewed',
  kVersusTutorialTwoKey: 'SKZFTUEVersusTutorialTwoViewed',
  kMatchSelectTutorialKey: 'SKZFTUEMatchSelectTutorialViewed',
  kMatchStreamTutorialKey: 'SKZFTUEMatchStreamTutorialViewed',
  kTabTutorialKey: 'SKZFTUETabTutorialViewed',
  kPLOWCompletedTutorialOneKey: 'SKZFTUEPLOWCompletedTutorialOneViewed',
  kPLOWCompletedTutorialTwoKey: 'SKZFTUEPLOWCompletedTutorialTwoViewed',
  kPLOWPendLossTutorialOneKey: 'SKZFTUEPLOWPendLossTutorialOneViewed',
  kPLOWPendLossTutorialTwoKey: 'SKZFTUEPLOWPendLossTutorialTwoViewed',
  kPLOWPendLossTutorialThreeKey: 'SKZFTUEPLOWPendLossTutorialThreeViewed',
  kFTUELegacyTabTutorialKey: 'SKZFirstTimeExperienceTabs',
  kShouldWalkthroughVersus: 'SKZFirstTimeExperienceVersus',
  kChatIntroSeenKey: 'SKZFTUEChatIntroViewed',
  kSecondMatchCompleted: 'SKZSecondMatchCompleted',
  kLiveBracketTutorial: 'SKZLiveBracketTutorialViewed',
};
